import * as React from "react";
import Menu from "@mui/material/Menu";
import {MenuItem} from "@mui/material";
import {NestedMenuItem} from "mui-nested-menu";

interface IProps {
    handleLeftMenuClick: Function;
    region: any;
    sectors: any;
}

const LeftMenuButton = (props: IProps) => {
    const [anchorEl, setAnchorEl] = React.useState<any>(null);
    const open = Boolean(anchorEl);

    const handleClick = (e: any) => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);
    const data = {
        "Donors": {
            "Bilateral": [
                "SFD",
                "QFS",
                "Canada",
                "Norway",
                "Denmark",
                "Australia",
                "UK",
                "US",
                "European Union",
                "Italy",
                "Korea",
                "France",
                "Germany",
                "KFW",
                "China"
            ],
            "Multilateral": [
                "IsDB",
                "JICA/ Japan",
                "Geneva Conference",
                "AIIB",
                "World Bank",
                "ADB"
            ]
        },
        "Sectors": {
            "SRO1": [
                "All",
                "Environment and Climate Change",
                "Disaster Risk Reduction and Resilience",
                "Governance"
            ],
            "SRO2": [
                "All",
                "Agriculture, Food, Livestock, and Fisheries",
                "Commerce and Industries",
                "Livelihoods"
            ],
            "SRO3": [
                "All",
                "Social Sustainability, Inclusion and Gender",
                "Social Protection, Livelihoods, and Jobs",
                "Culture and Heritage"
            ],
            "SRO4": [
                "All",
                "Education",
                "Health",
                "WASH, Municipal Services, and Community Infrastructure",
                "Transport and Communications",
                "Energy",
                "Housing",
                "Water Resources and Irrigation"
            ],
            "Others": [
                "All",
                "Finance and Markets",
                "Tourism"
            ]
        }
    }

    return (
        <div className={"button-div"}>
            <a onClick={(e) => handleClick(e)}>
                <img
                    src={props.region["imgSrc"]}
                    width="50px"
                    // height={ "32px"}
                    className="mx-auto"
                    style={{paddingBottom: "2rem"}}
                />
                <h6 className={"button-text"}>{props.region["title"]}</h6>
                {/*<div*/}
                {/*    id={props.region["name"] + "-toggle-div"}*/}
                {/*    style={{overflow: "auto"}}*/}
                {/*    className={props.region["name"] === "All" ? "left-active" : "left"}*/}
                {/*/>*/}
            </a>
            <Menu
                key={"menu-" + props.region["name"]}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <MenuItem
                    key={"MenuItem-" + props.region["name"] + "-All"}
                    onClick={(e) => {
                        handleClose();
                        props.handleLeftMenuClick(e, props.region, "All", "All", "All");
                    }}
                    sx={{minWidth: "150px"}}
                >
                    All
                </MenuItem>

                <NestedMenuItem
                    key={"NestedMenuItem-" + props.region["name"] + "-donors"}
                    label={"Development Partner"}
                    parentMenuOpen={open}
                    // sx={{backgroundColor: "#243b77", color: "white"}}
                >

                    {//@ts-ignore
                        Object.keys(data["Donors"]).map((donorType: string) => (
                            <NestedMenuItem
                                key={"NestedMenuItem-" + props.region["name"] + "-donors-" + donorType}
                                onClick={(e) => {
                                    handleClose();
                                }}
                                label={donorType}
                                parentMenuOpen={open}
                            >
                                {//@ts-ignore
                                    data["Donors"][donorType].map((donor: any) => (
                                        <MenuItem
                                            key={
                                                "MenuItem-" +
                                                props.region["name"] +
                                                "-AllDonors-dornos" +
                                                donor
                                            }
                                            onClick={(e) => {
                                                handleClose();
                                                props.handleLeftMenuClick(e, props.region, "All", "All", donor);
                                            }}
                                            sx={{minWidth: "150px"}}
                                        >
                                            {donor}
                                        </MenuItem>
                                    ))
                                }
                            </NestedMenuItem>
                        ))}

                </NestedMenuItem>

                <NestedMenuItem
                    key={"NestedMenuItem-" + props.region["name"] + "-sectors"}
                    label={"Sectors"}
                    parentMenuOpen={open}
                    // sx={{backgroundColor: "#243b77", color: "white"}}
                >

                    {//@ts-ignore
                        Object.keys(data["Sectors"]).map((sro: string) => (
                            <NestedMenuItem
                                key={"NestedMenuItem-" + props.region["name"] + "-" + sro}
                                onClick={(e) => {
                                    handleClose();
                                }}
                                label={sro}
                                parentMenuOpen={open}
                            >
                                {//@ts-ignore
                                    data["Sectors"][sro].map((sector: any) => (
                                        <MenuItem
                                            key={
                                                "MenuItem-" +
                                                props.region["name"] +
                                                "-AllSectors-" +
                                                sector
                                            }
                                            onClick={(e) => {
                                                handleClose();
                                                props.handleLeftMenuClick(e, props.region, sro, sector, "All");
                                            }}
                                            sx={{minWidth: "150px"}}
                                        >
                                            {sector}
                                        </MenuItem>
                                    ))
                                }
                            </NestedMenuItem>
                        ))}

                </NestedMenuItem>


            </Menu>
        </div>
    );
};

export default LeftMenuButton;
